import styled from 'styled-components';
import { PageWrap, media } from '@minerva-analytics/pantheon';

const QuestionContainer = styled(PageWrap)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.tablet`
  `}

  ${media.phone`
  `}
`;

export {
  QuestionContainer,
};
